import Vue from "vue";
import { mapState } from "vuex";

import actionBarComponent from "@/components/child/actionBar/actionBar.vue";
import checkboxComponent from "@/components/child/form/checkbox.vue";
import comboComponent from "@/components/child/form/combo.vue";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import Grid from "@/components/child/grid/grid";
import gridComponent from "@/components/child/grid/grid.vue";
import { GridAction } from "@/components/child/grid/gridAction";
import { GridColors, GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component, Watch } from "@/decorators";
import EnumExtensions from "@/models/enum/extensions/enumExtensions";
import StatusInventario from "@/models/enum/statusInventario";
import TipoInventario from "@/models/enum/tipoInventario";
import InventarioModel from "@/models/inventarioModel";
import UsuarioModel from "@/models/usuarioModel";
import estoqueService from "@/services/estoqueService";
import InventarioService from "@/services/inventarioService";
import grupoProdutoService from "@/services/produto/grupoProdutoService";
import { AppState, SessionActions } from "@/store/store";
import { sortArray } from "@/utils/common/array";
import "./edit.scss";

@Component({
    components: {
        actionBarComponent,
        checkboxComponent,
        comboComponent,
        fieldsetComponent,
        gridComponent,
    },
    computed: {
        ...mapState({
            usuarioLogado: (state: AppState) => state.session.usuarioLogado,
        }),
    },
})
export default class InventarioEditComponent extends Vue {
    // State computed props
    usuarioLogado: UsuarioModel;

    private colapsed = true;
    private desabilita = false;
    private totalProdutos = null;
    private iniciado = false;
    private consulta = false;
    private finalizado = false;
    private gridcomponent: Grid = null;
    private ignorarLotesZerados = true;

    private service = new InventarioService();
    private model = new InventarioModel();

    tipoInventarioOptions: Array<Object> = EnumExtensions.getNamesAndValuesOrderedByNames(TipoInventario);
    produtoGrupoOptions: Array<Object> = [];
    produtosFiltrados: Array<Object> = [];
    produtosMovimentacaoOptions: Array<Object> = [];
    produtosMovimentacaoFiltrados: Array<Object> = [];
    estoqueOptions: Array<object> = [];

    modelId = 0;

    total = 0;
    totalMovimentacoes = 0;

    gridData = [];
    extraSubActions: Array<object> = [];
    gridExtraSubActionsConfirmar: Array<GridAction> = [];

    //Produtos de inventario ativo
    pags: boolean = null;
    tipoDocGerar: number = null;
    inventarioIniciado = false;

    get produtoGridDataColumns() {
        return [
            new GridColumn("produtoId", "Cód", GridColumnType.String),
            new GridColumn("produtoDescricao", "Produto", GridColumnType.String),
            new GridColumn("quantidade", "Qtd. Disponivel", GridColumnType.Decimal),
            new GridColumn("quantidadeVencida", "Qtd. Vencido", GridColumnType.Decimal),
            new GridColumn("unidadeMedida", "Unid.", GridColumnType.String),
        ];
    }

    get loteGridDataColumns() {
        return [
            new GridColumn("loteDescricao", "Lote", GridColumnType.String),
            new GridColumn("sequencialCompra", "Seq.", GridColumnType.String),
            new GridColumn("dataFabricacao", "Data de Fabricação", GridColumnType.Date),
            new GridColumn("dataValidade", "Data de Validade", GridColumnType.Date),
            new GridColumn("quantidade", "Quantidade", GridColumnType.Decimal, true),
        ];
    }

    get produtoFinalizadoGridColumns() {
        return [
            new GridColumn("produtoId", "Cód.", GridColumnType.String),
            new GridColumn("produtoDescricao", "Produto", GridColumnType.String),
        ];
    }

    get loteFinalizadoGridColumns() {
        return [
            new GridColumn("loteDescricao", "Lote", GridColumnType.String),
            new GridColumn("sequencialCompra", "Seq.", GridColumnType.String),
            new GridColumn("dataCriacao", "Data de Criação", GridColumnType.Date),
            new GridColumn("dataValidade", "Validade do Lote", GridColumnType.Date),
            new GridColumn("quantidade", "Quantidade", GridColumnType.Decimal),
            new GridColumn("unidadeMedida", "Unidade", GridColumnType.String),
            new GridColumn("tipoMovimentacaoDescricao", "Tipo Movimentação", GridColumnType.String),
        ];
    }

    conditionShowSubData(it) {
        if (it["itens"] != null) {
            return it["itens"]["length"] > 0;
        }
        return false;
    }

    conditionMovimentacaoShowSubData(it) {
        if (it["itens"] != null) {
            return it["itens"]["length"] > 0;
        }
        return false;
    }

    private async onIniciar() {
        try {
            const isValid = await this.$validator.validateAll();
            if (isValid) {
                try {
                    const data = await this.service
                        .insertInventario(this.model)
                        .withLoading()
                        .resolveWithJSON<InventarioModel>();

                    this.inventarioIniciado = true;
                    this.model.updateFrom(data);

                    this.modelId = data.id;

                    this.listaProdutos();
                } catch {
                    this.$router.back();
                }
            } else {
                this.$focusErrorField();
            }
        } catch {}
    }

    private onFiltrar(textoBusca: string) {
        this.produtosFiltrados = this.gridData.filter(p =>
            p["produtoDescricao"].toLowerCase().includes(textoBusca.toLocaleLowerCase()),
        );
    }

    private onChangeSort(sortKey: keyof InventarioModel, sortOrder: "asc" | "desc") {
        sortArray(this.gridData, sortKey, sortOrder);
    }

    private onFiltrarConcluidos(textoBusca: string) {
        this.produtosMovimentacaoFiltrados = this.produtosMovimentacaoOptions.filter(p =>
            p["produtoDescricao"].toLowerCase().includes(textoBusca.toLocaleLowerCase()),
        );
    }

    private cancel() {
        this.$router.back();
    }

    private async listaProdutos() {
        this.iniciado = true;
        this.desabilita = true;

        try {
            this.gridData = await this.service
                .getLotesInventario(
                    this.ignorarLotesZerados,
                    this.model.estoqueId,
                    this.model.tipoInventario == 1 ? this.model.grupoInventarioId : 0,
                )
                .withLoading()
                .resolveWithJSON<[]>();

            this.extraSubActions.splice(0);
            this.gridExtraSubActionsConfirmar.splice(0);

            for (let index = 0; index < this.gridData.length; index++) {
                if (this.gridData[index].itens.length > 0) {
                    this.gridData[index].itens.forEach(() => {
                        this.gridExtraSubActionsConfirmar.push(
                            new GridAction(
                                "ajustar",
                                "Ajustar quantidade em estoque do lote",
                                "fa fa-check",
                                GridColors.GREEN,
                            ),
                        );
                    });
                } else {
                    this.gridExtraSubActionsConfirmar.push(
                        new GridAction(
                            "ajustar",
                            "Ajustar quantidade em estoque do lote",
                            "fa fa-check",
                            GridColors.GREEN,
                        ),
                    );
                }
            }

            this.extraSubActions.push(this.gridExtraSubActionsConfirmar);

            this.produtosFiltrados = this.gridData;
            this.totalProdutos = this.gridData.length;
            this.colapsed = false;
        } catch {}
    }

    private async getFinalizadp(id: number) {
        try {
            this.produtosMovimentacaoOptions = await this.service.getFinalizado(id).withLoading().resolveWithJSON<[]>();

            if (this.pags) {
                this.gridcomponent = this.$refs.gridcomponent as Grid;

                if (this.tipoDocGerar == 2) {
                    setTimeout(() => {
                        this.gridcomponent.gerarImpressao();
                    }, 2000);
                }

                setTimeout(() => {
                    this.pags = false;
                }, 2000);
            }

            this.totalMovimentacoes = this.produtosMovimentacaoOptions.length;
            this.produtosMovimentacaoFiltrados = this.produtosMovimentacaoOptions;

            this.colapsed = false;
        } catch {}
    }

    private async onCancelar() {
        const response = await this.$showQuestion(
            this.$t("__.ts.atencao"),
            this.$t("__.ts.todasAltRevertidas").toString() + this.$t("__.ts.desejaReverter").toString(),
            {
                cancelButtonText: this.$t("__.Crud.fechar") as string,
                confirmButtonText: this.$t("__.ts.reverter") as string,
            },
        );

        if (response) {
            const responseCancelar = await this.service
                .cancelarInventario(this.modelId)
                .withLoading()
                .resolveWithResponse();
            if (responseCancelar.ok) {
                await this.$showSuccess(this.$t("__.ts.inventCancelado"), this.$t("__.ts.inventCanceladoSucess"));

                this.$router.push("/inventario-lista");
            } else {
                await this.$showWarning(this.$t("__.ts.erro"), this.$t("__.ts.naoPossivCancelar"));
            }
        }
    }

    private async onFinalizar() {
        const response = await this.$showQuestion(
            this.$t("__.ts.atencao"),
            this.$t("__.ts.opcIraFinaliz").toString() + this.$t("__.ts.desejaProsseg").toString(),
            {
                cancelButtonText: this.$t("__.Crud.fechar") as string,
                confirmButtonText: this.$t("__.ts.finalizar") as string,
            },
        );

        if (response) {
            const responseUpdate = await this.service
                .finalizarInventario(this.modelId)
                .withLoading()
                .resolveWithResponse();

            if (responseUpdate.ok) {
                await this.$showSuccess(this.$t("__.ts.inventFinalizado"), this.$t("__.ts.inventFinalizadoSucess"));
                this.$router.push("/inventario-lista");
            } else {
                await this.$showWarning(this.$t("__.ts.erro"), this.$t("__.ts.naoPossivFinalizar"));
                this.$router.push("/inventario-lista");
            }
        }
    }

    private async onExtraSubAction(name: string, model: any) {
        if (name.trim() === "ajustar") {
            if (model.isControlado) {
                return this.$notifyError("", this.$t("__.ts.naoPossivelAlterarInv"));
            }
            await this.onInserirAjusteInventario(model);
        }
    }

    private async onInserirAjusteInventario(lote: any) {
        const response = await this.$showQuestion(
            this.$t("__.ts.atencao"),
            this.$t("__.ts.alteraQtdLote").toString() + this.$t("__.ts.desejaProsseg").toString(),
        );

        if (response) {
            const sucesso = await this.service
                .insertAjusteLote(this.model, lote.produtoLoteId, lote.quantidade)
                .withLoading()
                .resolveWithoutJSON();

            if (sucesso) {
                await this.$showSuccess(this.$t("__.ts.sucesso"), "Quantidade do lote alterado com sucesso!");
            }
        }
    }

    @Watch("pags")
    private onPags() {
        if (this.pags == null || this.pags == true) {
            this.load();
        }
    }

    private async load() {
        this.ignorarLotesZerados = false;
        this.desabilita = true;

        try {
            const data = await this.service.get(this.modelId).withLoading().resolveWithJSON<InventarioModel>();

            if (data.status == StatusInventario.Ativo) {
                this.inventarioIniciado = true;

                this.model.updateFrom(data);

                await this.listaProdutos();
            } else {
                this.consulta = true;
                this.finalizado = true;

                const statusDescricao = StatusInventario[data.status];

                if (!this.pags) {
                    this.$showWarning(
                        this.$t("__.ts.inventario") + statusDescricao + "!",
                        this.$t("__.ts.inventFinalizadoSoConsul"),
                    );
                }

                await this.getFinalizadp(this.modelId);
            }
        } catch {}
    }

    private async mounted() {
        await this.$store.dispatch(SessionActions.LOAD_USUARIO_LOGADO);

        const response = await Promise.all([
            estoqueService.comboCached(this.usuarioLogado.franquiaId),
            grupoProdutoService.comboCached(this.usuarioLogado.franquiaId),
        ]);
        this.estoqueOptions = response[0];
        this.produtoGrupoOptions = response[1];

        if (this.$route.params.id) {
            this.modelId = +this.$route.params.id;
            this.load();
        } else if (this.estoqueOptions.length === 1) {
            this.model.estoqueId = this.estoqueOptions[0]["value"];
        }
    }
}
